import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Text } from "@radix-ui/themes";
import clsx from "clsx";
import { namespaceClassNames } from "./utils";
export const Marker = React.forwardRef(function Marker({ children, className, highContrast, ...props }, forwardedRef) {
    return (_jsx(Text, { ref: forwardedRef, className: clsx(className, namespaceClassNames("marker")), ...props, children: _jsx("span", { className: namespaceClassNames("marker-circle"), children: _jsx("span", { className: namespaceClassNames("marker-content"), children: children }) }) }));
});
//# sourceMappingURL=marker.js.map